import { render, staticRenderFns } from "./ResignModal.vue?vue&type=template&id=c80f8b5e&scoped=true"
import script from "./ResignModal.vue?vue&type=script&lang=js"
export * from "./ResignModal.vue?vue&type=script&lang=js"
import style0 from "./ResignModal.vue?vue&type=style&index=0&id=c80f8b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80f8b5e",
  null
  
)

export default component.exports